export const projects = [
  {
    id: 'margala-garden-housing',
    title: 'Margala Garden Co-operative Housing Society',
    location: 'Islamabad E-19',
    category: 'Residential',
    subcategory: 'plots',
    city: 'Islamabad',
    featured: true,
    plotSizes: ['5 Marla', '10 Marla', '1 Kanal'],
    priceFrom: 'PKR 1,700,000',
    status: 'Available',
    description: 'A premier residential community designed for modern living with secure gated infrastructure, lush green surroundings, and prime investment potential in the heart of Islamabad E-19.',
    image: 'https://readdy.ai/api/search-image?query=aerial%20view%20of%20a%20modern%20gated%20residential%20community%20with%20wide%20roads%20green%20parks%20and%20modern%20houses%20in%20Islamabad%20Pakistan%20warm%20golden%20hour%20lighting%20high%20quality%20architectural%20photography%20realistic%204k&width=800&height=600&seq=101&orientation=landscape',
    features: [
      'Secure Gated Community',
      'Green & Peaceful Environment',
      'Wide Carpeted Roads',
      'Modern Infrastructure',
      'High Investment Potential',
      'Community Living',
    ],
    gallery: [
      'https://readdy.ai/api/search-image?query=modern%20luxury%20residential%20plot%20development%20in%20Islamabad%20Pakistan%20with%20green%20landscaping%20and%20wide%20roads%20professional%20real%20estate%20photography%20warm%20lighting&width=600&height=400&seq=102&orientation=landscape',
      'https://readdy.ai/api/search-image?query=beautiful%20residential%20community%20park%20with%20modern%20houses%20and%20green%20trees%20in%20Islamabad%20evening%20light%20high%20quality&width=600&height=400&seq=103&orientation=landscape',
      'https://readdy.ai/api/search-image?query=modern%20wide%20road%20inside%20a%20gated%20community%20with%20street%20lights%20and%20green%20medians%20Islamabad%20Pakistan&width=600&height=400&seq=104&orientation=landscape',
    ],
    mapEmbed: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3321.0771234567!2d72.9123!3d33.6844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzPCsDQxJzAzLjgiTiA3MsKwNTQnNDQuMyJF!5e0!3m2!1sen!2s!4v1600000000000!5m2!1sen!2s',
    paymentPlan: 'Cash payment only. Possession-ready plots — no waiting period. Full ownership transfer upon payment completion.',
    faq: [
      { q: 'What plot sizes are available?', a: 'We offer 5 Marla, 10 Marla, and 1 Kanal residential plots in Margala Garden Co-operative Housing Society.' },
      { q: 'Is this a NOC-approved society?', a: 'Yes, Margala Garden Co-operative Housing Society has all necessary NOCs and approvals from relevant authorities.' },
      { q: 'Is there an installment plan available?', a: 'This project is offered on a cash-only basis. These are possession-ready plots with immediate ownership transfer upon full payment — no waiting period required.' },
      { q: 'Can overseas Pakistanis invest?', a: 'Absolutely. We provide complete remote assistance for overseas Pakistani investors including documentation and payment support.' },
      { q: 'What is the booking process?', a: 'Simply contact us via WhatsApp or call. We will guide you through document submission and full cash payment to complete your booking smoothly.' },
    ],
  },
  {
    id: 'blue-world-city',
    title: 'Blue World City',
    location: 'Chakri Road, Islamabad',
    category: 'Residential',
    subcategory: 'plots',
    city: 'Islamabad',
    featured: true,
    plotSizes: ['5 Marla', '10 Marla', '1 Kanal', '2 Kanal'],
    priceFrom: 'PKR 1,800,000',
    status: 'Available',
    description: 'One of the most anticipated housing societies near the new Islamabad International Airport, offering world-class amenities and exceptional investment returns.',
    image: 'https://readdy.ai/api/search-image?query=modern%20housing%20society%20aerial%20view%20with%20wide%20roads%20parks%20and%20modern%20villas%20near%20airport%20Islamabad%20Pakistan%20dusk%20lighting%204k&width=800&height=600&seq=105&orientation=landscape',
    features: [
      'Near Islamabad Airport',
      'Wide Main Boulevard',
      'Theme Parks & Entertainment',
      'Commercial District',
      'High Return on Investment',
      '24/7 Security',
    ],
    gallery: [],
    mapEmbed: '',
    paymentPlan: '',
    faq: [],
  },
  {
    id: 'park-view-city',
    title: 'Park View City',
    location: 'Malir Cantt, Karachi',
    category: 'Residential',
    subcategory: 'apartments',
    city: 'Karachi',
    featured: true,
    plotSizes: ['1 Bed', '2 Bed', '3 Bed', 'Penthouse'],
    priceFrom: 'PKR 15,000,000',
    status: 'Available',
    description: 'Premium residential apartments in Karachi with stunning views, modern amenities, and a secure gated environment perfect for families and investors alike.',
    image: 'https://readdy.ai/api/search-image?query=modern%20luxury%20high%20rise%20apartment%20building%20with%20glass%20facade%20and%20green%20surroundings%20Karachi%20Pakistan%20evening%20sky%20professional%20architecture%20photography&width=800&height=600&seq=106&orientation=landscape',
    features: [
      'Luxury Apartments',
      'Rooftop Pool & Gym',
      'Underground Parking',
      'Smart Home Features',
      'Park View Balconies',
      'Commercial Complex',
    ],
    gallery: [],
    mapEmbed: '',
    paymentPlan: '',
    faq: [],
  },
  {
    id: 'dha-valley',
    title: 'DHA Valley',
    location: 'Islamabad Expressway',
    category: 'Residential',
    subcategory: 'plots',
    city: 'Islamabad',
    featured: false,
    plotSizes: ['5 Marla', '10 Marla', '1 Kanal'],
    priceFrom: 'PKR 3,200,000',
    status: 'Available',
    description: 'Prestigious DHA development offering premium residential plots on Islamabad Expressway with excellent connectivity and high appreciation potential.',
    image: 'https://readdy.ai/api/search-image?query=prestigious%20residential%20housing%20society%20with%20modern%20infrastructure%20and%20green%20spaces%20along%20expressway%20Islamabad%20Pakistan&width=800&height=600&seq=107&orientation=landscape',
    features: [],
    gallery: [],
    mapEmbed: '',
    paymentPlan: '',
    faq: [],
  },
  {
    id: 'capital-smart-city',
    title: 'Capital Smart City',
    location: 'M-2 Motorway, Islamabad',
    category: 'Residential',
    subcategory: 'plots',
    city: 'Islamabad',
    featured: false,
    plotSizes: ['5 Marla', '7 Marla', '10 Marla', '1 Kanal', '2 Kanal'],
    priceFrom: 'PKR 2,100,000',
    status: 'Available',
    description: 'Pakistan\'s first smart city featuring cutting-edge technology, sustainable living, and futuristic urban planning on the M-2 Motorway.',
    image: 'https://readdy.ai/api/search-image?query=futuristic%20smart%20city%20aerial%20concept%20with%20modern%20buildings%20green%20spaces%20and%20smart%20infrastructure%20Pakistan%20warm%20evening%20lighting&width=800&height=600&seq=108&orientation=landscape',
    features: [],
    gallery: [],
    mapEmbed: '',
    paymentPlan: '',
    faq: [],
  },
  {
    id: 'nova-city',
    title: 'Nova City',
    location: 'Fateh Jang Road, Islamabad',
    category: 'Commercial',
    subcategory: 'plots',
    city: 'Islamabad',
    featured: false,
    plotSizes: ['4 Marla', '8 Marla', '1 Kanal'],
    priceFrom: 'PKR 1,500,000',
    status: 'Available',
    description: 'Affordable luxury living with modern infrastructure and a focus on community development along Fateh Jang Road, ideal for both living and investment.',
    image: 'https://readdy.ai/api/search-image?query=affordable%20modern%20housing%20society%20with%20wide%20roads%20street%20lights%20and%20green%20parks%20in%20Islamabad%20Pakistan%20real%20estate&width=800&height=600&seq=109&orientation=landscape',
    features: [],
    gallery: [],
    mapEmbed: '',
    paymentPlan: '',
    faq: [],
  },
];

export const projectCategories = [
  { id: 'all', label: 'All Projects' },
  { id: 'residential', label: 'Residential' },
  { id: 'commercial', label: 'Commercial' },
  { id: 'plots', label: 'Plots' },
  { id: 'apartments', label: 'Apartments' },
  { id: 'featured', label: 'Featured' },
];

export const cities = [
  { id: 'all', label: 'All Cities' },
  { id: 'Islamabad', label: 'Islamabad' },
  { id: 'Karachi', label: 'Karachi' },
  { id: 'Lahore', label: 'Lahore' },
  { id: 'Rawalpindi', label: 'Rawalpindi' },
];